import { render } from "./RoleView.vue?vue&type=template&id=72a1982b&scoped=true"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"

import "./RoleView.vue?vue&type=style&index=0&id=72a1982b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a1982b"]])

export default __exports__